<!-- <nav-bar></nav-bar> -->
<!-- <p-growl [life]="3000" [sticky]="false" [(value)]="messages"></p-growl> -->
<p-toast [sticky]="false"></p-toast>

<p-confirmDialog></p-confirmDialog>
<nav-bar></nav-bar>

<div>
  <!-- Header page -->
  <div class="header-fixed-top" [ngClass]="{'empty': isAssistanceCasesEmpty() != true ? true : false}">
    <!-- <input type="text" class="form-control search-input" placeholder="{{ 'Search' | translate }}" aria-label="Username" aria-label="basic-addon1"> -->
    <div class="row" style="width: 100%;">
      <div class="col" style="display: flex;">
        <app-search-case
          (onSelect)="selectCase($event)" (onClear)="clearCase()"
          (onQuery)="onQueryMember($event)"
          [clear]="caseSearchClear">
        </app-search-case>
        <img alt="" [ngClass]="{'img-assistance-empty': isAssistanceCasesEmpty() != true ? true : false}"
          [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/filter_white.svg' | company" style="cursor: pointer;" (click)="showModalFilter()">
        <strong style="margin: 7px 4px; color: #FFF;">
          ({{ totalCount }})
        </strong>
      </div>
      <div class="col">
        <button type="button" class="btn btn-light btn primary-btn"
        (click)="asignUsers()" *ngIf="isAssistanceCasesEmpty()" style="width: fit-content; border: 1px solid #FFF !important;">
        {{ 'Manage users' | translate }}
      </button>
      </div>
    </div>
  </div>

  <!-- Cases -->
  <div class="cases-from-list" *ngIf="isAssistanceCasesEmpty() && !showDialog">
    <div>
      <div *ngFor="let assistancecase of assistancecases">
        <div style="display: none;" [ngClass]="{'display': getTicketsAssistanceCase(assistancecase) != undefined ? false: false}"></div>
        <!-- Card Black -->
        <div class="card" [ngClass]="{'blue': getColorValue(assistancecase.id) == 'blue' && assistancecase.status == 1 ? true : false,
                                      'red_': getColorValue(assistancecase.id) == 'red' && assistancecase.status == 1 ? true : false,
                                      'yellow_': getColorValue(assistancecase.id) == 'yellow' && assistancecase.status == 1 ? true : false,
                                      'black': getColorValue(assistancecase.id) == 'black' && assistancecase.status == 1 ? true : false,
                                      'grey': getColorValue(assistancecase.id) == 'grey' && assistancecase.status == 1 ? true : false,
                                      
                                      'blue-cl': getColorValue(assistancecase.id) == 'blue' && assistancecase.status == 2 ? true : false,
                                      'red-cl': getColorValue(assistancecase.id) == 'red' && assistancecase.status == 2 ? true : false,
                                      'yellow-cl': getColorValue(assistancecase.id) == 'yellow' && assistancecase.status == 2 ? true : false,
                                      'black-cl': getColorValue(assistancecase.id) == 'black' && assistancecase.status == 2 ? true : false
                                    }">
          <div class="card-body">

            <div class="card-body-container">
              <div class="card-body-checkbox">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" (click)="$event.stopPropagation()"
                    [(ngModel)]="assistancecase.selected">
                </div>
              </div>

              <table class="table-casses" aria-label="attendancetable">
                <th scope="col"></th>
                <!-- Columna superior -->
                <tr class="end-card">
                  <!-- Datos Asistencia -->
                  <td class="top-card">
                    <p class="space-medium"><strong>{{ 'Attendance data' | translate }}</strong></p>
                    <div class="center-data">
                      <p>
                        <img alt="" *ngIf="assistancecase.services[0].id == 332" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-grua.svg' | company">
                        <img alt="" *ngIf="assistancecase.services[0].id == 333" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-llanta.svg' | company">
                        <img alt="" *ngIf="assistancecase.services[0].id == 334" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-corriente.svg' | company">
                        <img alt="" *ngIf="assistancecase.services[0].id == 335" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-gas.svg' | company">
                        <img alt="" *ngIf="assistancecase.services[0].id == 336" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-llave.svg' | company">
                        <!-- {{ assistancecase.services ? assistancecase.services[0].category.name : '' }} - -->
                        {{ assistancecase.services ? assistancecase.services[0].name : '' }}
                        <!-- <button (click)="test()"></button> -->
                      </p>
                      <p>
                        {{ assistancecase.plan ? assistancecase.plan.name : '' }}
                      </p>
                    </div>
                  </td>

                  <!-- Datos Gestion -->
                  <td class="top-card">
                    <div class="row" style="width: inherit; margin-right: 0px !important; margin-left: auto;">
                      <div class="col-1" >
                        <img alt="" *ngIf="validateColor(assistancecase.services,assistancecase.programmed_datetime,assistancecase.plan,assistancecase.country.id) == 1" class="bandera-position" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/bandera_roja.svg' | company">
                        <img alt="" *ngIf="validateColor(assistancecase.services,assistancecase.programmed_datetime,assistancecase.plan,assistancecase.country.id) == 2" class="bandera-position" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/bandera_morada.svg' | company">
                        <img alt="" *ngIf="validateColor(assistancecase.services,assistancecase.programmed_datetime,assistancecase.plan,assistancecase.country.id) == 3" class="bandera-position" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/bandera_verde.svg' | company">
                        
                        <app-flags [country]="assistancecase.country"></app-flags>
                      </div>
                      <div class="col-6">
                        <p><strong>{{ 'Management data' | translate }} #{{assistancecase.id}}</strong></p>
                      </div>
                      <div class="col-5" style="display: flex; justify-content: center;">  
                        <!--<p><img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-programmed.svg' | company" style="width: 1rem; margin: 0px 0px 0px 0px; margin-top: -0.25rem; margin-right: 5px;"><b>{{getDate(assistancecase.date_start)}}</b></p>-->
                        <p><strong>{{ assistancecase.date_start | currentDate: {hourTimeZone} | date: 'dd-MM-yyyy HH:mm' }}</strong></p>

                      </div>
                    </div>        
                    <div class="center-data">
                      <p [ngClass]="{'green_': assistancecase.created_by ? false : true}" *ngIf="assistancecase.created_by_user ? true : false">
                        {{ 'Operator' | translate }} : {{ assistancecase.created_by_user ? assistancecase.created_by_user.email : '' }}
                      </p>
                      <p [ngClass]="{'green_': assistancecase.created_by ? true : false}" *ngIf="assistancecase.created_by ? true : false">
                        {{ 'Dispatcher' | translate }} : {{ assistancecase.created_by ? assistancecase.created_by.email : '' }}
                      </p>
                    </div>
                  </td>

                  <!-- Datos cliente -->
                  <td class="top-card" style="padding-right: 2.5rem;">
                    <!-- <img alt="" class="bandera-position" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/bandera_roja.svg' | company"> -->

                    <div
                      *ngIf="assistancecase.reassigned_operator_case || assistancecase.reassigned_dispatcher_case || assistancecase.reassigned_tracking_case"
                      class="reassigned_user_case"
                      title="{{ 'Reassigned user case' | translate }}"
                    >
                      <i class="fas fa-user-friends" aria-hidden="true"></i>
                    </div>
                    
                    


                    <p class="space-medium"><strong>{{ 'Client data' | translate }}</strong></p>
                    <div class="center-data">
                      <p>
                        <i class="far fa-user" aria-hidden="true"></i> {{ assistancecase.contact_name }}
                      </p>
                      <p>
                        #{{ 'Policy' | translate }}
                        <strong>
                          {{ assistancecase.assistance_sale ? assistancecase.assistance_sale.code : '' }}
                        </strong>
                      </p>
                    </div>
                  </td>
                </tr>

                <!-- Columna inferior -->
                <tr class="end-card down" style="background-color: white;">
                  <td colspan="3" class="end-card justify" style="height: 35px;">
                    <div class="div-left" (click)=test(assistancecase)>
                      <img alt="" class="img-space-rigth" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/clock-' + (getColorValue(assistancecase.id) || 'black') + '.svg' | company"
                          (click)="setDialogValue(assistancecase.id)">
                      <!-- DIALOG DE TIEMPOS -->
                      <p-dialog header="{{'Management Times' | translate }}" [modal]="true" [(visible)]="dialogTimer[assistancecase.id]">
                        <app-assistance-case-times-pop-up
                          [assistancecase]="assistancecase"
                          [filter]="filter"
                          (case)="setColorValue($event)"
                          (client)="setColorClientValue($event)"
                          (operator)="setColorOperatorValue($event)"
                          (dispatcher)="setColorDispatcherValue($event)"
                          (provider)="setColorProviderValue($event)">
                        </app-assistance-case-times-pop-up>
                      </p-dialog>
                      <app-assistance-case-times
                        [assistancecase]="assistancecase"
                        (case)="setColorValue($event)"
                        (client)="setColorClientValue($event)"
                        (operator)="setColorOperatorValue($event)"
                        (dispatcher)="setColorDispatcherValue($event)"
                        (provider)="setColorProviderValue($event)">
                      </app-assistance-case-times>
                    </div>

                    <!-- VISTA DESPACHADOR -->
                    <div class="div-rigth" *ngIf="isOnlyDispatcherRole">
                      <div class="a-left">
                        <!-- Si fuera Espera de asignacion -->
                        <div class="options-size" *ngIf="(getStatusCase(assistancecase.id) == 'provider_pending' ? true : false) && (timeToAssignProvider[assistancecase.id] != true)">
                          <p [ngClass]="{'blue': getColorValue(assistancecase.id) == 'blue' ? true : false,
                            'red_': getColorValue(assistancecase.id) == 'red' ? true : false,
                            'yellow_': getColorValue(assistancecase.id) == 'yellow' ? true : false}">
                            {{ 'Waiting for supplier assignment' | translate }}
                            <app-progressbar-timer-negative
                              [starttime]="assistancecase.date_start"
                              (end)="completeTimer($event,assistancecase.id)">
                            </app-progressbar-timer-negative>
                          </p>
                        </div>

                        <!-- Si se tuviera que asignar Proveedor manualmente -->
                        <div class="options-size" *ngIf="(getStatusCase(assistancecase.id) == 'provider_pending' ? true : false) && (timeToAssignProvider[assistancecase.id] == true)">
                          <!-- <button type="button" class="btn btn-light btn primary-btn-assign" (click)="showModalSave()">{{ 'assign_provider' | translate }}</button> -->
                        </div>

                        <!-- Si ya tuviera asigando un proveedor -->
                        <div class="options-size" *ngIf="getStatusCase(assistancecase.id) == 'assign_provider' ? true : false">
                          <!-- <button type="button" class="btn btn-light btn primary-btn-coor" (click)="showModalSave()">{{ 'Coordinate Assistance' | translate }}</button> -->
                        </div>

                        <!-- Si ya tuviera asigando un proveedor -->
                        <div class="options-size" *ngIf="getStatusCase(assistancecase.id) == 'notify_provider' ? true : false">
                          <!-- <button type="button" class="btn btn-light btn primary-btn-coor" (click)="showModalSave()">{{ 'Coordinate Assistance' | translate }}</button> -->
                        </div>

                        <!-- Si ya tuviera asigando un proveedor -->
                        <div class="options-size" *ngIf="getStatusCase(assistancecase.id) == 'provider_arrived' ? true : false">
                          <!-- <button type="button" class="btn btn-light btn primary-btn-coor" (click)="showModalSave()"> {{ 'Coordinate Assistance' | translate }}</button> -->
                        </div>
                      </div>
                      <div>
                        <a routerLink="/admin/assistance/cases/{{assistancecase.id}}/tickets/{{filter.status}}{{ filter.member_id ? ('/' + filter.member_id) : ''}}"
                        target="_blank">
                          <img alt="" class="img-space-pointer" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/eye.svg' | company">
                        </a>
                      </div>
                    </div>

                    <!-- VISTA OPERADOR -->
                    <div class="div-rigth" *ngIf="!isOnlyDispatcherRole">
                      <!-- Si fuera Operador -->
                      <div class="a-left">
                        <!-- Si fuera pendiente por abrir -->
                        <div *ngIf="getColorValue(assistancecase.id) == 'black' ? true : false">
                          <img alt="" class="img-space-rigth right" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/warning.svg' | company">
                          <strong>{{ 'Pending to open' | translate }}</strong>
                        </div>

                        <!-- Si fuera Espera de asignacion -->
                        <div class="options-size" *ngIf="(getStatusCase(assistancecase.id) == 'provider_pending' ? true : false) && (timeToAssignProvider[assistancecase.id] != true)">
                          <p [ngClass]="{'blue': getColorValue(assistancecase.id) == 'blue' ? true : false,
                            'red_': getColorValue(assistancecase.id) == 'red' ? true : false,
                            'yellow_': getColorValue(assistancecase.id) == 'yellow' ? true : false}">
                            {{ 'Waiting for supplier assignment' | translate }}
                            <app-progressbar-timer-negative
                              [starttime]="assistancecase.date_start"
                              (end)="completeTimer($event,assistancecase.id)">
                            </app-progressbar-timer-negative>
                          </p>
                        </div>

                        <!-- Si fuera Espera de asignacion -->
                        <div class="options-size" *ngIf="(getStatusCase(assistancecase.id) == 'provider_pending' ? true : false) && (timeToAssignProvider[assistancecase.id] == true)">
                          <div *ngIf="getStatusCase(assistancecase.id)" class="d-inline  me-3"><strong>{{ 'State' | translate}}:</strong><aside class="d-inline text-info"> {{ getStatusCase(assistancecase.id) | translate }}</aside></div> 
                        </div>

                        <!-- Si ya tuviera asigando un proveedor -->
                        <div class="options-size" *ngIf="getStatusCase(assistancecase.id) == 'assign_provider' ? true : false">
                          <div *ngIf="getStatusCase(assistancecase.id)" class="d-inline  me-3"><strong>{{ 'State' | translate}}:</strong><aside class="d-inline text-info"> {{ getStatusCase(assistancecase.id) | translate }}</aside></div> 
                          <strong>{{ 'Provider' | translate }}:</strong>
                          <p class="timer-space-left">{{getProviderName(assistancecase.id)}}</p>
                        </div>

                        <div class="options-size" *ngIf="getStatusCase(assistancecase.id) == 'reimbursement' ? true : false">
                          <div *ngIf="getStatusCase(assistancecase.id)" class="d-inline  me-3"><strong>{{ 'State' | translate}}:</strong><aside class="d-inline text-info"> {{ getStatusCase(assistancecase.id) | translate }}</aside></div> 
                          <strong>{{ 'Provider' | translate }}:</strong>
                          <p class="timer-space-left">{{getProviderName(assistancecase.id)}}</p>
                        </div>

                        <!-- Si ya tuviera asigando un proveedor -->
                        <div class="options-size" *ngIf="getStatusCase(assistancecase.id) == 'notify_provider' ? true : false">
                          <div *ngIf="getStatusCase(assistancecase.id)" class="d-inline  me-3"><strong>{{ 'State' | translate}}:</strong><aside class="d-inline text-info"> {{ getStatusCase(assistancecase.id) | translate }}</aside></div> 
                          <strong>{{ 'Provider' | translate }}:</strong>
                          <p class="timer-space-left">{{getProviderName(assistancecase.id)}}</p>
                        </div>

                        <!-- Si ya tuviera asigando un proveedor -->
                        <div class="options-size" *ngIf="getStatusCase(assistancecase.id) == 'provider_arrived' ? true : false">
                          <div *ngIf="getStatusCase(assistancecase.id)" class="d-inline  me-3"><strong>{{ 'State' | translate}}:</strong><aside class="d-inline text-info"> {{ getStatusCase(assistancecase.id) | translate }}</aside></div> 
                          <strong>{{ 'Provider' | translate }}:</strong>
                          <p class="timer-space-left">{{getProviderName(assistancecase.id)}}</p>
                        </div>
                      </div>

                      <div>
                        <a routerLink="/admin/assistance/cases/{{assistancecase.id}}/tickets/{{filter.status}}{{ filter.member_id ? ('/' + filter.member_id) : ''}}"
                        target="_blank">
                          <img alt="" class="img-space-pointer" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/eye.svg' | company">
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
              
          </div>
        </div>
        <!-- End Card -->

      </div>
    </div>
    <div class="center">
      <p-paginator
        [rows]="10" [totalRecords]="totalCount" [pageLinkSize]="10"
        (onPageChange)="nextPage($event)">
      </p-paginator>
    </div>
  </div>

  <!-- Vista de Cases vacia -->
  <div class="display-empty-mother" *ngIf="!isAssistanceCasesEmpty() && !showDialog">
    <div class="display-empty">
      <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/assistancecases_empty.svg' | company">
      <div class="display-flex-column">
        <h1><strong>{{ 'Congratulations!' | translate }}</strong></h1>
        <h2>{{ 'Your procedures are up to date' | translate }}</h2>
        <button type="button" class="btn btn-light btn primary-btn mrg-tp"
          (click)="showModalSave()" *ngIf="!isAssistanceCasesEmpty()">
          {{ 'Create Assistance Case' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="showDialog">
    <app-assistance-cases-form
      [assistancecase]="assistancecase"
      [states]="states"
      [caseLocation]="caseLocation"
      [countries]="countries"
      [startCount]="startCount"
      [newMember]="newMember"
      [newMemberCountry]="newMemberCountry"
      [editevent]="editevent"
      [reset]="createTicket"
      (create)="onSave($event)"
      (changeMessageNavBar) = "changeMessageNavBar($event)"
      [messageService]="messageService"
      (memberCreate)="createMember($event)"
      #assistanceCasesForm>
    </app-assistance-cases-form>
  </div>
</div>

<div class="container-fluid" *ngIf="false">
  <div class="row">
    <!-- Assistance Case List -->
    <div class="col-sm-12 col-md-12">
      <div class="card">
        <div class="card-container">
          <div class="title-panel">
            <div class="form-inline">
              <div class="form-group">
                <h1>
                  {{ 'Assistance Case Assignment' | translate }} ({{ totalCount }})
                </h1>
              </div>
              <div class="form-group mg-top-10px search-container mg-right-15px">
                <app-search-case
                  (onSelect)="selectCase($event)" (onClear)="clearCase()"
                  (onQuery)="onQueryMember($event)"
                  [clear]="caseSearchClear">
                </app-search-case>
              </div>

              <div class="form-group mg-top-10px mg-right-15px">
                <button class="btn btn-primary btn-sm" (click)="showModalFilter()">
                  <i class="fa fa-filter" aria-hidden="true"></i>
                  {{ 'Filters' | translate }}
                </button>
                <button class="btn btn-warning btn-sm" (click)="refresh()">
                  <i class="fa fa-refresh" aria-hidden="true"></i>
                  {{ 'Refresh' | translate }}
                </button>
                <button class="btn btn-danger btn-sm" (click)="clearSelection()">
                  <i class="fa fa-close" aria-hidden="true"></i>
                  {{ 'Clear selection' | translate }}
                </button>
                <button class="btn btn-success btn-sm" (click)="asignUsers()">
                  <i class="fa fa-users" aria-hidden="true"></i>
                  {{ 'Manage users' | translate }}
                </button>
              </div>
            </div>
          </div>


          <div class="filters-added-panel">
            <span class="filters-title">
              <i class="fa fa-filter" aria-hidden="true"></i>
              {{ 'Filters' | translate }}:
            </span>
            <span *ngIf="filter.id" class="filter">
              <span class="lbl">
                {{ 'ID' | translate }}:
              </span>
              <span class="value">
                {{ filter.id }}<span class="comma">,</span>
              </span>
            </span>
            <span *ngIf="filterMember" class="filter">
              <span class="lbl">
                {{ 'Client' | translate }}:
              </span>
              <span class="value">
                {{ filterMember.name }}<span class="comma">,</span>
              </span>
            </span>
            <span *ngIf="filter.user_id" class="filter">
              <span class="lbl">
                {{ 'User' | translate }}:
              </span>
              <span class="value">
                {{ filterUserName }}<span class="comma">,</span>
              </span>
            </span>
            <span *ngIf="filter.created_by_user_id" class="filter">
              <span class="lbl">
                {{ 'Created by' | translate }}:
              </span>
              <span class="value">
                {{ filterCreatedByUserName }}<span class="comma">,</span>
              </span>
            </span>
            <span class="filter">
              <span class="lbl">
                {{ 'Status' | translate }}:
              </span>
              <span *ngIf="filter.status == 0" class="value">
                {{ 'Any Status' | translate }}<span class="comma">,</span>
              </span>
              <span *ngIf="filter.status == 1" class="value">
                {{ 'Open' | translate }}<span class="comma">,</span>
              </span>
              <span *ngIf="filter.status == 2" class="value">
                {{ 'Closed' | translate }}<span class="comma">,</span>
              </span>
            </span>
            <span *ngIf="filter.from_date" class="filter">
              <span class="lbl">
                {{ 'From' | translate }}:
              </span>
              <span class="value">
                {{ filter.from_date }}<span class="comma">,</span>
              </span>
            </span>
            <span *ngIf="filter.to_date" class="filter">
              <span class="lbl">
                {{ 'To' | translate }}:
              </span>
              <span class="value">
                {{ filter.to_date }}<span class="comma">,</span>
              </span>
            </span>
            <span *ngIf="filterCountryName" class="filter">
              <span class="lbl">
                {{ 'Country' | translate }}:
              </span>
              <span class="value">
                {{ filterCountryName }}<span class="comma">,</span>
              </span>
            </span>
            <span *ngIf="filterProductName" class="filter">
              <span class="lbl">
                {{ 'Product' | translate }}:
              </span>
              <span class="value">
                {{ filterProductName }}<span class="comma">,</span>
              </span>
            </span>
            <span *ngIf="filterCategoryName" class="filter">
              <span class="lbl">
                {{ 'Type of Services' | translate }}:
              </span>
              <span class="value">
                {{ filterCategoryName }}<span class="comma">,</span>
              </span>
            </span>
            <span *ngIf="filter.exception_ticket" class="filter">
              <span class="lbl">
                {{ 'Exceptions' | translate }}:
              </span>
              <span *ngIf="filter.exception_ticket === 2" class="value">
                {{ 'No' }}<span class="comma">,</span>
              </span>
              <span *ngIf="filter.exception_ticket === 1" class="value">
                {{ 'Yes' | translate }}<span class="comma">,</span>
              </span>
            </span>
            <span *ngIf="filter.programmed_ticket" class="filter">
              <span class="lbl">
                {{ 'Programmed' | translate }}:
              </span>
              <span *ngIf="filter.programmed_ticket === 2" class="value">
                {{ 'No' }}<span class="comma">,</span>
              </span>
              <span *ngIf="filter.programmed_ticket === 1" class="value">
                {{ 'Yes' | translate }}<span class="comma">,</span>
              </span>
            </span>
            <span *ngIf="filterProviderName" class="filter">
              <span class="lbl">
                {{ 'Provider' | translate }}:
              </span>
              <span class="value">
                {{ filterProviderName }}
              </span>
            </span>
          </div>

          <div class="content-panel">
            <div class="table-responsive">
              <table class="table table-condensed table-hover cases-table" aria-label="operatortable">
                <thead style="background:#f9f9f9">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">{{ 'ID' | translate }}</th>
                    <th scope="col">
                      {{ 'Operator' | translate }}
                    </th>
                    <th scope="col">
                      {{ 'Dispatcher' | translate }}
                    </th>
                    <th scope="col">
                      {{ 'Client' | translate }}
                    </th>
                    <th scope="col">
                      {{ 'Client Status' | translate }}
                    </th>
                    <th scope="col">
                      {{ 'Product' | translate }}
                    </th>
                    <th scope="col">
                      {{ 'Services' | translate }}
                    </th>
                    <th scope="col">
                      {{ 'Elapsed Time' | translate }}
                    </th>
                     <th scope="col">
                      {{ 'Times' | translate }}
                    </th>
                    <th scope="col"></th>
                    <th scope="col" class="status-col">
                      {{ 'Status' | translate }}
                    </th>
                    <th scope="col"></th>
                    <th scope="col"  ></th>
                  </tr>
                </thead>
                <tbody>
                 <!--  <tr *ngFor="let assistancecase of assistancecases" [ngClass]="{'programmed_case':(assistancecase.programmed_datetime)}">
                   <tr *ngFor="let assistancecase of assistancecases" [ngClass]="getSomeClass(assistancecase.services[0].id,assistancecase.programmed_datetime)">-->
                    <tr *ngFor="let assistancecase of assistancecases" [ngClass]="getSomeClass(assistancecase.services,assistancecase.programmed_datetime,assistancecase.plan,assistancecase.country.id)">
                    <!-- Country Flag -->
                    <td>
                      <app-flags [country]="assistancecase.country"></app-flags>
                    </td>
                    <!-- ID -->
                    <td>
                      <a routerLink="/admin/assistance/cases/{{assistancecase.id}}/tickets/{{filter.status}}{{ filter.member_id ? ('/' + filter.member_id) : ''}}"
                        target="_blank">
                        {{assistancecase.id}}
                      </a>
                    </td>
                    <!-- Operator -->
                    <td>
                      <a routerLink="/admin/assistance/cases/{{assistancecase.id}}/tickets/{{filter.status}}{{ filter.member_id ? ('/' + filter.member_id) : ''}}"
                        target="_blank">
                        {{ assistancecase.created_by_user ? assistancecase.created_by_user.email : '---' }}
                      </a>
                    </td>
                    <!-- Dispatcher -->
                    <td>
                      <a routerLink="/admin/assistance/cases/{{assistancecase.id}}/tickets/{{filter.status}}{{ filter.member_id ? ('/' + filter.member_id) : ''}}"
                        target="_blank">
                        {{ assistancecase.created_by ? assistancecase.created_by.email : '---' }}
                      </a>
                    </td>
                    <!-- Client -->
                    <td>
                      <a routerLink="/admin/assistance/cases/{{assistancecase.id}}/tickets/{{filter.status}}{{ filter.member_id ? ('/' + filter.member_id) : ''}}"
                        target="_blank">
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                        <a class="member-info" (mouseenter)="showMemberInfo(assistancecase)"
                          style="color: black; text-decoration: none">
                          <span
                            (mouseenter)="memberInfo.toggle($event)"
                            (mouseleave)="memberInfo.hide()" class="cursor-help">
                            {{ assistancecase.contact_name }}
                          </span>
                        </a>
                      </a>
                    </td>
                    <!-- member status -->
                    <td>
                      {{
                        (assistancecase.member_status ==1) ?
                          ('Active' | translate) : ('Pending'| translate)
                      }}
                    </td>
                    <!-- Product -->
                    <td>
                      {{ assistancecase.plan ? assistancecase.plan.name : '' }}
                    </td>
                    <!-- Services -->
                    <td [ngClass]="{'programmed_case':(assistancecase.programmed_datetime)}">
                      <table aria-label="servicetable">
                        <th scope="col"></th>
                        <tbody>
                          <tr *ngFor="let service of assistancecase.services">
                            <td>
                              &#8226; {{service.name}}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <!-- Elapsed time -->
                    <td>

                      <div>
                        <table aria-label="servicetable2" style="margin-bottom: 5px;" [ngClass]="{'programmed_case':(assistancecase.programmed_datetime)}">
                          <th scope="col"></th>
                          <tbody>
                            <tr *ngFor="let service of assistancecase.services">
                              <td *ngIf="service.ticket_type">
                                &#8226; {{ service.ticket_type | translate }}
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- <div *ngIf="assistancecase.status == 1"> -->
                        <table aria-label="ticketstable" [ngClass]="{'programmed_case':(assistancecase.programmed_datetime)}">
                          <th scope="col"></th>
                          <tbody>
                            <tr *ngFor="let service of assistancecase.services">
                              <td *ngIf="service.tickets" style="min-width: 150px;">

                                <!-- Time to asign provider (programmed and not programmed) -->
                                <!--
                                  Muestra tiempo de asignación de proveedor para normales y programadas
                                -->
                                <div *ngIf="!service.arrivalStartTime && !service.programedTicketStartTime && assistancecase.status == 1">
                                  <div class="row">
                                    <div style="padding-right: 0;" class="col-md-2">
                                      <i title="{{ 'Notify Provider' | translate }}" style="font-size: 20px" class="fa fa-truck"></i>
                                    </div>
                                    <div class="col-md-10">
                                      <app-progressbar-timer [starttime]="assistancecase.date_start"
                                        [maxSeconds]="(+service.expected_time * 60)"
                                        [redSeconds]="(+service.expected_time * 60)">
                                      </app-progressbar-timer>
                                    </div>
                                  </div>
                                </div>
                                <div *ngIf="!service.arrivalStartTime && service.programedTicketStartTime && assistancecase.status == 1">
                                  <div class="row">
                                    <div style="padding-right: 0;" class="col-md-2">
                                      <i title="{{ 'Notify Provider' | translate }}" style="font-size: 20px" class="fa fa-truck"></i>
                                    </div>
                                    <div class="col-md-10">
                                      <app-progressbar-timer [starttime]="service.programedTicketStartTime"
                                        [maxSeconds]="(+service.expected_time * 60)"
                                        [redSeconds]="(+service.expected_time * 60)">
                                      </app-progressbar-timer>
                                    </div>
                                  </div>
                                </div>

                                <!-- Time to notify to customer (Programmed and not programmed) -->
                                <div *ngIf="service.arrivalStartTime && !service.programedTicketStartTime">
                                  <div class="row">
                                    <div style="padding-right: 0;" class="col-md-2">
                                      <i title="{{ 'Notify to customer' | translate }}" style="font-size: 20px" class="fa fa-phone-square"></i>
                                    </div>
                                    <div class="col-md-10">
                                      <!--
                                        Ocurre en dado caso no es una asistencia programada y si ya se asigno provider
                                      -->
                                      <app-progressbar-timer *ngIf="!service.notifyToCustomerEndTime && assistancecase.status == 1"
                                        [starttime]="service.arrivalStartTime"
                                        [maxSeconds]="(+service.expected_time_customer * 60)" [yellowSeconds]="1"
                                        [redSeconds]="(+service.expected_time_customer * 60)">
                                      </app-progressbar-timer>
                                      <app-progressbar-timer *ngIf="!service.notifyToCustomerEndTime && assistancecase.status == 2"
                                        [starttime]="service.arrivalStartTime"
                                        [endtime]="assistancecase.date_end" [setColorBlue]="true"
                                        [maxSeconds]="(+service.expected_time_customer * 60)" [yellowSeconds]="1"
                                        [redSeconds]="(+service.expected_time_customer * 60)">
                                      </app-progressbar-timer>
                                      <app-progressbar-timer *ngIf="service.notifyToCustomerEndTime"
                                        [starttime]="service.arrivalStartTime"
                                        [endtime]="service.notifyToCustomerEndTime" [setColorBlue]="true"
                                        [maxSeconds]="(+service.expected_time_customer * 60)" [yellowSeconds]="1"
                                        [redSeconds]="(+service.expected_time_customer * 60)">
                                      </app-progressbar-timer>
                                    </div>
                                  </div>
                                </div>
                                <div *ngIf="service.arrivalStartTime && service.programedTicketStartTime">
                                  <div class="row">
                                    <div style="padding-right: 0;" class="col-md-2">
                                      <i title="{{ 'Notify to customer' | translate }}" style="font-size: 20px" class="fa fa-phone-square"></i>
                                    </div>
                                    <div class="col-md-10">
                                      <!--
                                        Ocurren si son asistencias programadas y si ya se asignó provider

                                        Si no tiene endtime notify to customer:
                                        - Iniciar el timer en fecha de asignacion de proveedor (arrival) si la asignacion de proveedor
                                        se realizó después (es mayor) que la fecha de programación.
                                        - Caso contrario se iniciará en la fecha de programación porque no es posible asignar
                                        proveedor antes de llegar el tiempo de gestión.
                                      -->
                                      <app-progressbar-timer *ngIf="!service.notifyToCustomerEndTime && service.programedTicketStartTime < service.arrivalStartTime"
                                        [starttime]="service.arrivalStartTime"
                                        [maxSeconds]="(+service.expected_time_customer * 60)" [yellowSeconds]="1"
                                        [redSeconds]="(+service.expected_time_customer * 60)">
                                      </app-progressbar-timer>
                                      <app-progressbar-timer *ngIf="!service.notifyToCustomerEndTime && service.programedTicketStartTime > service.arrivalStartTime"
                                        [starttime]="service.programedTicketStartTime"
                                        [maxSeconds]="(+service.expected_time_customer * 60)" [yellowSeconds]="1"
                                        [redSeconds]="(+service.expected_time_customer * 60)">
                                      </app-progressbar-timer>

                                      <!--
                                        Si tiene endtime notify to customer
                                        - el mismo caso de uso del anterior con la excepción que tendrá el endtime correspondiente
                                      -->
                                      <app-progressbar-timer *ngIf="service.notifyToCustomerEndTime && service.programedTicketStartTime < service.arrivalStartTime"
                                        [starttime]="service.arrivalStartTime"
                                        [endtime]="service.notifyToCustomerEndTime" [setColorBlue]="true"
                                        [maxSeconds]="(+service.expected_time_customer * 60)" [yellowSeconds]="1"
                                        [redSeconds]="(+service.expected_time_customer * 60)">
                                      </app-progressbar-timer>
                                      <app-progressbar-timer *ngIf="service.notifyToCustomerEndTime && service.programedTicketStartTime > service.arrivalStartTime"
                                        [starttime]="service.programedTicketStartTime"
                                        [endtime]="service.notifyToCustomerEndTime" [setColorBlue]="true"
                                        [maxSeconds]="(+service.expected_time_customer * 60)" [yellowSeconds]="1"
                                        [redSeconds]="(+service.expected_time_customer * 60)">
                                      </app-progressbar-timer>
                                    </div>
                                  </div>
                                </div>

                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>

                    <!-- Times -->
                    <td>
                      <a class="member-info nowrap" (mouseenter)="showTimes(assistancecase)"
                          style="color: black; text-decoration: none">
                        <i class="fa fa-angle-down" aria-hidden="true">
                        </i>
                          <span
                            (mouseenter)="times.toggle($event)" (mouseleave)="times.hide()"
                            class="cursor-help">
                            {{
                              assistancecase.date_start
                              | currentDate: { offset:hourTimeZone }
                              | date:'MMM' | translate
                            }}
                            {{
                              assistancecase.date_start
                              | currentDate: { offset:hourTimeZone }
                              | date:'d' | translate
                            }},
                            {{
                              assistancecase.date_start
                              | currentDate: { offset:hourTimeZone }
                              | date:'hh:mm a'
                            }}
                          </span>
                        </a>
                    </td>
                    <!-- See Case + Bills + Feed Back -->
                    <td>
                      <!-- See Case  -->
                      <a class="btn btn-primary btn-xs"
                        routerLink="/admin/assistance/cases/{{assistancecase.id}}/tickets/{{filter.status}}{{ filter.member_id ? ('/' + filter.member_id) : ''}}"
                        target="_blank">
                         {{ 'See Case' | translate }}
                      </a>
                      <!-- Bills -->
                      <a
                        *ngIf="assistancecase.status == 2 && iAm([
                          'assistance_admin', 'supervisor','operator', 'cabin_agent', 'networkleader'
                        ])"
                        class="btn btn-default btn-xs"
                        routerLink="/admin/assistance/cases/{{assistancecase.id}}/bills/{{filter.status}}/{{filter.member_id}}"
                        target="_blank">
                        {{ 'Bills' | translate }}
                      </a>

                          <!-- QA Survey -->
                          <span
                          *ngIf="assistancecase.status == 2
                            && !assistancecase.surveyanswered
                            && iAm(['assistance_admin', 'quality'])">
                          <span class="btn btn-xs btn-default"
                          (click)="submenu_qa(assistancecase)">
                            {{ 'Cabin Survey' | translate }}
                          </span>
                        </span>

                      <!-- Feedback -->
                      <span
                        *ngIf="iAm([
                          'assistance_admin', 'supervisor', 'quality', 'networkleader'
                        ])">
                        <span
                          *ngIf="assistancecase.status == 2
                            && assistancecase.rating_status != 1
                            && assistancecase.rating_status != 2"
                          class="btn btn-xs btn-default"
                          (click)="submenu_qa3(assistancecase)">
                          <i *ngFor="let s of star"
                            class="select-rating fa fa-lg fa-star-o" aria-hidden="true">
                          </i>
                        </span>
                      </span>



                      <span
                      >
                      <span
                        *ngIf="assistancecase.status == 2
                          && assistancecase.rating_status == 1"
                        class="btn btn-xs btn-default"
                        (click)="submenu_qa2(assistancecase)">
                        <i *ngFor="let s of star"
                          class="select-rating fa fa-lg fa-star-o" aria-hidden="true">
                        </i>
                      </span>
                    </span>
                    </td>
                    <!-- Status -->
                    <td class="status-col">
                      <select
                        class="form-control input-xs" [(ngModel)]="assistancecase.status"
                        (ngModelChange)="changeStatus(assistancecase)" #statusSelected>
                        <option [ngValue]="1">{{ 'Open' | translate }}</option>
                        <option [ngValue]="2">{{ 'Closed' | translate }}</option>
                      </select>
                    </td>
                    <td>
                      <span
                        *ngIf="assistancecase.status === 1"
                        (click)="changeStatus(assistancecase)"
                        style="color: red">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                      </span>
                    </td>
                    <td>
                      <a (click)="onSelectsearchCase(assistancecase)"
                        *ngIf="iAm([
                          'assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'networkleader'
                        ])">
                        <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="inline-paginator">
              <p-paginator
                [rows]="20" [totalRecords]="totalCount" [pageLinkSize]="3"
                (onPageChange)="nextPage($event)">
              </p-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- create new member -->
<p-dialog
  [(visible)]="memberDialog" [responsive]="true"
  [modal]="true" [draggable]="false"
  [breakpoint]="500" [blockScroll]="true"
  (onHide)="cancelMember()">
  <ng-template pTemplate="header">
    
    {{ 'Create Client' | translate }}
  
  </ng-template>
  
  <app-member-form
    [member]="member"
    [editmember]="editmember"
    [status]="memberstate_flag"
    [countries]="countries"
    [memberLocation]="memberLocation"
    [requiredEmail]="false"
    (create)="onMemberSave($event)"
    (cancelEvent)="cancelMember()">
  </app-member-form>
</p-dialog>

<!-- member info -->
<p-popover #memberInfo>
  <div class="user" *ngIf="assistancecaseInfo && assistancecaseInfo.member">
    <div>
      <p>
        <strong>{{ 'Phone' | translate }}: </strong>
        <a href="tel:{{ assistancecaseInfo.phone }}">
          {{ assistancecaseInfo.phone }}
        </a>
      </p>
      <p *ngIf="assistancecaseInfo.phone2">
        <strong>{{ 'Secondary Phone' | translate }}: </strong>
        <a href="tel:{{ assistancecaseInfo.phone2 }}">
          {{ assistancecaseInfo.phone2 }}
        </a>
      </p>
      <p>
        <strong>{{ 'Address' | translate }}: </strong>
        {{ assistancecaseInfo.address }}
      </p>
    </div>
  </div>
</p-popover>

<!-- times -->
<p-popover #times>
  <div class="user" *ngIf="assistancecaseTime && assistancecaseTime.date_start">
    <div>
      {{ assistancecaseTime.date_start | daysOffset | async }}
    </div>
  </div>
</p-popover>

<!-- rating and comment -->
<p-dialog
  [(visible)]="showDialogFeedback" [responsive]="true" [modal]="true"
  [draggable]="false" [breakpoint]="500"
  [class.ui-dialog-titlebar]="true" [blockScroll]="true">
  <ng-template pTemplate="header">
    {{ 'Feedback' | translate }}
  </ng-template>
  

  <form  class="form-horizontal" #form="ngForm" (ngSubmit)="saveFeedback()">
    <legend>{{ 'Case' | translate }}</legend>

    <div class="question">
      <div class="form-group">
        <table aria-label="answeredtable" class="col-sm-12">
          <th scope="col"></th>
          <tr>
            <td class="control-label col-sm-3">
              <label>{{ 'Answered the Call' | translate }}:</label>
            </td>
            <td
              class="col-sm-1"
              style="text-align: right; padding-right: 0px;">
              <input
                type="radio"
                [(ngModel)]="assistancecaseFeedback.rating_status"
                (ngModelChange)="onSelectRatingStatus($event)" name="rating_status"
                [value]=1 required>
            </td>
            <td
              class="col-sm-1" style="text-align: left; cursor:pointer"
              (click)="onSelectRatingStatus(1)">
              {{ 'Yes'  | translate }}
            </td>
            <td
              class="col-sm-1" style="text-align: right; padding-right: 0px;">
              <input
                type="radio" [(ngModel)]="assistancecaseFeedback.rating_status"
                (ngModelChange)="onSelectRatingStatus($event)" name="rating_status"
                [value]=0 required>
            </td>
            <td
              class="col-sm-1" style="text-align: left; cursor:pointer"
              (click)="onSelectRatingStatus(0)">
              {{ 'No' | translate }}
            </td>
            <td
              class="col-sm-1" style="text-align: right; padding-right: 0px;">
              <input
                type="radio" [(ngModel)]="assistancecaseFeedback.rating_status"
                (ngModelChange)="onSelectRatingStatus($event)" name="rating_status"
                [value]=2 required>
            </td>
            <td
              class="col-sm-4" style="text-align: left; cursor:pointer"
              (click)="onSelectRatingStatus(2)">
              {{ "Doesn't Apply" | translate }}
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div *ngIf="showquestions">
      <div class="question">
        <div class="form-group">
          <div class="col-sm-12">
            <label class="control-label question">
              {{ 'How do you rate the speed in which we attended you call?' | translate }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <select
              class="form-control"
              [(ngModel)]="assistancecaseFeedback.speed_rating"
              name="speed_rating" (ngModelChange)="onSpeedRating($event)"
              #speed_rating required>
              <option *ngFor="let speed of ratings" [ngValue]="speed.val">
                {{ speed.text }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="question">
        <div class="form-group">
          <div class="col-sm-12">
            <label class="control-label question">
              {{ 'How do you rate the service in the phone call?' | translate }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <select
              class="form-control"
              [(ngModel)]="assistancecaseFeedback.phone_rating"
              name="phone_rating" (ngModelChange)="onPhoneRating($event)"
              #phone_rating required>
              <option *ngFor="let phone of ratings" [ngValue]="phone.val">
                {{ phone.text }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="question">
        <div class="form-group">
          <div class="col-sm-12">
            <label class="control-label question">
              {{
                'How do you rate the arrival time of our technician to the place?'
                | translate
              }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <select
              class="form-control"
              [(ngModel)]="assistancecaseFeedback.time_rating" name="time_rating"
              (ngModelChange)="onTimeRating($event)" #time_rating required>
              <option *ngFor="let time of ratings" [ngValue]="time.val">
                {{ time.text }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="question">
        <div class="form-group">
          <div class="col-sm-12">
            <label class="control-label question">
              {{ 'How do you rate the service given by our technician?' | translate }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <select
              class="form-control"
              [(ngModel)]="assistancecaseFeedback.service_rating"
              name="service_rating" (ngModelChange)="onServiceRating($event)"
              #service_rating required>
              <option *ngFor="let service of ratings" [ngValue]="service.val">
                {{ service.text }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="question">
        <div class="form-group">
          <div class="col-sm-12">
            <label class="control-label question">
              {{
                'How much effort did it took you to get in touch with our emergency cabin and fix your problem?'
                | translate
              }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <select
              class="form-control"
              [(ngModel)]="assistancecaseFeedback.effort_rating"
              name="effort_rating" (ngModelChange)="onEffortRating($event)"
              #effort_rating required>
              <option *ngFor="let effort of effort_ratings" [ngValue]="effort.val">
                {{ effort.text }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="question">
        <div class="form-group">
          <div class="col-sm-12" *ngIf="!fieldsRequired['recommendation_rating']">
            <label class="control-label question">
              {{
                  'From 1 to 10 how much would you recommend the assistance to your family and friends?'
                  | translate
              }}
            </label>
          </div>
          <div class="col-sm-12" style="color: red" *ngIf="fieldsRequired['recommendation_rating']">
            <label class="control-label question">
              {{
                'From 1 to 10 how much would you recommend the assistance to your family and friends?'
                | translate
              }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-offset-3 col-sm-9">
            <i
              *ngFor="let recommendation of rating"
              class="select-rating fa-2x fa-star fa{{recommendation < selectedRecommendation ? 's' : 'r'}}"
              (click)="selectRecommendation(recommendation)"
              (mouseover)='hoverRecommendation(recommendation)'
              (mouseleave)="leaveRecommendation()" aria-hidden="true">
            </i>
            <span *ngIf="hoverRecommendationValue">
              {{hoverRecommendationValue}}/10
            </span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">
          {{ 'Client Comment' | translate }}:
        </label>
        <div class="col-sm-9">
          <textarea
            class="form-control" [(ngModel)]="assistancecaseFeedback.member_comment"
            name="Comment">
          </textarea>
        </div>
      </div>

      <div class="form-group" *ngIf="showReason">
        <label class="control-label col-sm-3">
          {{ 'Reason' | translate }}:
        </label>
        <div class="col-sm-9">
          <select
            class="form-control" [(ngModel)]="assistancecaseFeedback.reason"
            (ngModelChange)="onSelectReason($event)" name="reason" required>
            <option *ngFor="let r of reason" value= {{r.val}} >
              {{r.text | translate}}
            </option>
          </select>
        </div>
      </div>

      <div *ngFor="let service of services; let i = index">
        <legend>{{service.name}}</legend>
        <div class="form-group">
          <label class="control-label col-sm-3">
            {{ 'Rating' | translate }}:
          </label>
          <div class="col-sm-9">
            <i
              *ngFor="let r of rating"
              class="select-rating fa-star fa-2x fa{{r < service.rating ? 's' : 'r'}}"
               (click)="selectRating(r, i)" (mouseover)='hoverStarService(r, i)'
               (mouseleave)="leaveHoverStarService(r, i)" aria-hidden="true">
            </i>
            <span *ngIf="service.hoverStar">{{service.hoverStar}}/10</span>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-3">{{ 'Comment' | translate }}:</label>
          <div class="col-sm-9">
            <textarea
              class="form-control" [(ngModel)]="service.comment" name="Comment_{{i}}">
            </textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-offset-3 col-sm-9 div-btn-right">
        <button type="button" class="btn btn-default btn-sm" (click)="onCancel()">
          {{ 'Cancel' | translate }}
        </button>
        <button
          *ngIf="showquestions" type="submit" class="btn btn-primary btn-sm"
          [disabled]="form.form.invalid || form.form.pending || disabled">
          {{ 'Save' | translate }}
        </button>
        <button
          *ngIf="!showquestions" type="submit" class="btn btn-primary btn-sm"
          [disabled]="disabled">
          {{ 'Save' | translate }}
        </button>
      </div>
    </div>
  </form>
</p-dialog>

<!-- Dialog filter -->
<p-dialog
  [(visible)]="showDialogFilter" [responsive]="true"
  [modal]="true" [draggable]="false" [breakpoint]="500"
  [class.ui-dialog-titlebar]="true" [blockScroll]="true" [style]="{width: '80vw'}">
  <ng-template pTemplate="header">
    {{ 'Filters' | translate }}
  </ng-template>
  
  <div class="filer-div-space-display row">
    <!-- <div class="col-12">
      <div>
        <p><b> {{ 'General Filters' | translate }} </b></p>
      </div>
    </div> -->
    <div class="filer-div-space col-6">
      <div class="filter-div-display">
        <div class="filer-div-md">
          <label>
            {{ 'Case Number' | translate}}
          </label>
          <input type="number" name="case_id" class="form-control" min="0" (ngModelChange)="onSelectCaseId($event)" [ngModel]="filter.id" #case_id="ngModel">
        </div>
        <div class="filer-div-md">
          <label>
            {{ 'Policy' | translate}}
          </label>
          <input  name="code" class="form-control" min="0"  (ngModelChange)="onSelectPolicy($event)" [ngModel]="filter.code" #code="ngModel">
        </div>
        <!--<div class="filer-div-md">
          <label>
            {{ 'Client Name' | translate}}
          </label>
          <app-members-search
            (onSelect)="onSelectMemberFilter($event)"
            (onClear)="onClearSelectMember()"
            [newMember]="newMember" [assistanceCase]="true"
            (onQuery)="onQueryMember($event)" [style]="{'width':'30%'}"
            [placeholder]="'Member'">
          </app-members-search>
        </div>-->
      </div>
      <div class="row">
        <div class="col">
          <div class="filter-item">
            <label>
              {{ 'Serie' | translate}}
            </label>
            <input  name="serial" class="form-control" min="0"  (ngModelChange)="onSelectSerial($event)" [ngModel]="filter.serial" #serial="ngModel">
          </div>
        </div>
      </div>
      

      <!-- <div class="filter-div-display column title">
        <p><b> {{ 'Filter by Date' | translate }} </b></p>
      </div> -->

      <div class="filter-div-display column w-100">
        <label>
          {{ 'From' | translate }}
        </label>
        <div class="DateFilters">
          <app-select-date
            [notSetDate]="true" [editdate]="filter.from_date"
            (seteditday)="onSelectFromDate($event)">
          </app-select-date>
        </div>
      </div>

      <div class="filter-div-display column w-100">
        <label class="lbl-top-margin">
          {{ 'To' | translate }}
        </label>
        <div class="DateFilters">
          <app-select-date
            [notSetDate]="true" [editdate]="filter.to_date"
            (seteditday)="onSelectToDate($event)">
          </app-select-date>
          <strong class="text-danger" *ngIf="dates_valid === false">
            {{ 'The maximum range allowed is 31 days' | translate }}
          </strong>
        </div>
      </div>

    </div>

    <div class="filer-div-space col-6">

      <div class="filter-div-display">
        <div class="filer-div-md">
          <label>
            {{ 'Case status' | translate}}
          </label>
          <select class="form-control input-sm" [(ngModel)]="filter.ticket_status" [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null">{{ 'Any Status' | translate }}</option>
            <option [ngValue]="1">{{ 'Assign Service' | translate }}</option>
            <option [ngValue]="2">{{ 'Assign Provider' | translate }}</option>
            <option [ngValue]="3">{{ 'Notify to customer' | translate }}</option>
            <option [ngValue]="4">{{ 'Provider Arrived' | translate }}</option>
            <option [ngValue]="50">{{ 'Arrival registered from the app' | translate }}</option>
            <option [ngValue]="15">{{ 'reimbursement' | translate }}</option>
          </select>
        </div>
        <div class="filer-div-md">
          <label>
            {{ 'Sort' | translate}}
          </label>
          <select class="form-control input-sm" [(ngModel)]="filter.sorting" [ngModelOptions]="{standalone: true}">
            <option selected [ngValue]="1">{{ 'Descendent' | translate }}</option>
            <option [ngValue]="2">{{ 'Ascendent' | translate }}</option>
          </select>
        </div>
      </div>

      <div class="filter-div-display">
        <div class="filer-div-md">
          <label>
            {{ 'Status' | translate }}
          </label>
          <select class="form-control input-sm" [(ngModel)]="filter.status" [ngModelOptions]="{standalone: true}">
            <option [ngValue]="0">{{ 'Any Status' | translate }}</option>
            <option [ngValue]="1">{{ 'Open' | translate }}</option>
            <option [ngValue]="2">{{ 'Closed' | translate }}</option>
          </select>
        </div>
        <!-- <div class="filer-div-md space">
          <div class="filer-div-md">
            <label>
              {{ 'Exception' | translate }}
            </label>
            <br>
            <button (click)="filterException(1)" id="btnYexception" class="surveyBtn">
              {{ 'Yes' | translate}}
            </button>
            <button (click)="filterException(2)" id="btnNexception" class="surveyBtn">
              {{ 'No' | translate}}
            </button>    
          </div>
          <div class="filer-div-md">
            <label>
              {{ 'Programmed' | translate }}
            </label>
            <br>
            <button (click)="filterProgrammed(1)" id="btnYprogramed" class="surveyBtn">
              {{ 'Yes' | translate}}
            </button>
            <button (click)="filterProgrammed(2)" id="btnNprogramed" class="surveyBtn">
              {{ 'No' | translate}}
            </button>
          </div>
        </div> -->
        <div class="filer-div-md">
          <label>
            {{ 'Country' | translate }}
          </label>
          <div>
            <select
              class="form-control input-sm"
              (ngModelChange)="onSelectCountryFilter($event)"
              [(ngModel)]="filter.country_id" [ngModelOptions]="{standalone: true}">
              <option [ngValue]="null">---</option>
              <option *ngFor="let country of countries" [ngValue]="country.id">
                {{ country.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      

      <!-- <div>
        <p><b> {{ 'Additional Filters' | translate }} </b></p>
      </div> -->

      <div class="filter-div-display">
        
        <div class="filer-div-md">
          <label>
            {{ 'State of Republic' | translate }}
          </label>
          <div>
            <select
              class="form-control input-sm"
              (ngModelChange)="onSelectCountryStateFilter($event)"
              [(ngModel)]="filter.country_state_id" [ngModelOptions]="{standalone: true}">
              <option [ngValue]="null">---</option>
              <option *ngFor="let country_state of country_states" [ngValue]="country_state.id">
                {{ country_state.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="filer-div-md">
          <label>
            {{ 'Service' | translate }}:
          </label>
          <select class="form-control input-sm" [(ngModel)]="filter.service_id"
           name="service">
           services_filter
            <option [ngValue]="null">---</option>
            <option *ngFor="let service of services_filter"
              value={{service.id}}>
              <span>{{service.name}}</span>
            </option>
          </select>
        </div>
        <!--  -->
      </div>

      <div class="filter-div-display">
        <!-- <div class="filer-div-md">
          <label>
            {{ 'Type of Assistance' | translate }}
          </label>
          <select
            class="form-control input-sm" [(ngModel)]="filter.category_id"
            (ngModelChange)="onSelectCategory($event)"
            [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null">---</option>
            <option *ngFor="let category of categories" [ngValue]="category.id">
              {{ category.name }}
            </option>
          </select>
        </div> -->
        <div class="filer-div-md">
          <label>
            {{ 'Product' | translate }}
          </label>
          <select class="form-control input-sm" [(ngModel)]="filter.assistance_id"
            (ngModelChange)="onSelectProduct($event)"
            [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null">---</option>
            <option *ngFor="let product of products" [ngValue]="product.id">
              {{ product.id }} - {{ product.name }}
            </option>
          </select>
        </div>
        <div class="filer-div-md">
          <label>
            {{ 'Assistance Plan' | translate }}
          </label>
          <select class="form-control input-sm" [(ngModel)]="filter.assistance_plan_id"
            (ngModelChange)="onSelectProductPlan($event)"
            [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null">---</option>
            <option *ngFor="let plan of assistanceplans" [ngValue]="plan.id">
              {{ plan.id }} - {{ plan.name }}
            </option>
          </select>
        </div>
        
      </div>

      <!-- <div class="filter-div-display">
        <div class="filer-div-md">
          <label class="lbl-top-margin">
            {{ 'Provider' | translate }}
          </label>
          <div>
            <select
              class="form-control input-sm" [(ngModel)]="filter.provider_id"
              [ngModelOptions]="{standalone: true}">
              <option [ngValue]="null">---</option>
              <option *ngFor="let provider of providers" [ngValue]="provider.id">
              {{ provider.name }}
            </option>
            </select>
          </div>
        </div>
        <div class="filer-div-md">
        </div>
      </div> -->

      <!-- <div class="filter-div-display column title">
        <p><b> {{ 'By letter coverage' | translate }} </b></p>
      </div>

      <div class="filter-div-display column">
        <label>
          {{ 'Company name' | translate }}
        </label>
        <input type="text" name="client_name" class="form-control">
      </div> -->

    </div>

    <div class="filer-div-space col-12">

      <div class="row my-3">
        <div class="col">
          <div *ngIf="!myTickets" class="filter-item">
            <label class="lbl-top-margin">
              {{ 'Dispatcher' | translate }}
            </label>

            <p-autocomplete
            name="dispatcher_array_pchip"
            [(ngModel)]="dispatcher_array"
            placeholder="{{ 'Enter a dispatcher and press enter' | translate }}"
            [unique]="true"
            styleClass="ng-chips"
            [multiple]="true"
            [suggestions]="[]"
            >
          </p-autocomplete>

            <!-- <app-user-select (onSelect)="onSelectUser($event)" (onClear)="onClearSelectUser()"
              (onQuery)="onQueryUser($event)">
            </app-user-select> -->
          </div>
        </div>
      </div>

      <div class="row my-3">
        <div class="col">
          <div *ngIf="!myTickets" class="filter-item">
            <label class="lbl-top-margin">
              {{ 'Operator' | translate }}
            </label>

            <p-autocomplete
            name="operator_array_pchip"
            [(ngModel)]="operator_array"
            placeholder="{{ 'Enter a operator and press enter' | translate }}"
            [unique]="true"
            styleClass="ng-chips"
            [multiple]="true"
            [suggestions]="[]"
            >
          </p-autocomplete>
            <!-- <app-user-select
              (onSelect)="onSelectCreatedByUser($event)" (onClear)="onClearSelectCreatedByUser()"
              (onQuery)="onQueryCreatedByUser($event)">
            </app-user-select> -->
          </div>
        </div>
      </div>

      <div class="row my-3" *ngIf="filter.country_id">
        <div class="col">
          <div *ngIf="!myTickets" class="filter-item">
            <label class="lbl-top-margin">
              {{ 'Assistance Provider' | translate }}
            </label>
            <app-assistance-provider-select
              [country_id]="filter.country_id"
              (onSelect)="onSelectAssistanceProvider($event)" (onClear)="onClearSelectAssistanceProvider()"
              (onQuery)="onQueryAssistanceProvider($event)">
            </app-assistance-provider-select>
          </div>
        </div>
      </div>

      

      <div class="row my-3">
        <div class="col">
          <div *ngIf="!myTickets" class="filter-item">
            <label>
              {{ 'Client Name' | translate}}
            </label>
            <app-members-search
              (onSelect)="onSelectMemberFilter($event)"
              (onClear)="onClearSelectMember()"
              [newMember]="newMember" [assistanceCase]="true"
              (onQuery)="onQueryMember($event)" [style]="{'width':'30%'}"
              [placeholder]="'Member'">
            </app-members-search>
          </div>
        </div>
      </div>

      <!-- <div class="row my-3">
        <div class="col">
          <div *ngIf="!myTickets" class="filter-item">
            <label class="lbl-top-margin">
              {{ 'By letter coverage' | translate }}
            </label>
            <app-coverage-letter-select
              (onSelect)="onSelectCoverageLetter($event)" (onClear)="onClearSelectCoverageLetter()"
              (onQuery)="onQueryCoverageLetter($event)">
            </app-coverage-letter-select>
          </div>
        </div>
      </div> -->
      
    </div>

  </div>
  <br>
  <hr class="hr-height">
  <div class="filer-div-end">
    <button
      class="btn btn-light btn primary-btn" [disabled]="disabled"
      (click)="filterAssistanceCase()" style="width: 15rem; font-weight: bold;">
      {{ 'Filter' | translate }}
    </button>
  </div>

</p-dialog>


<!-- Download Report -->
<p-dialog
  [(visible)]="showDialogDownloadReport"
  [modal]="true" [draggable]="false"
  [blockScroll]="true" [style]="{width: '25vw'}" >
  <ng-template pTemplate="header">
    {{ 'Download Report' | translate }}
  </ng-template>
  
  <form  class="form-horizontal row" (ngSubmit)="saveDownloadReport()">
    <div class="form-group col-md-12">
      <label class="control-label col-sm-12">
        <strong>{{ 'File Type' | translate }}</strong>
      </label>
      <div class="col-sm-12">
        <select
          class="form-control" [(ngModel)]="downloadReport.file_type"
          name="file_type">
          <option value="xlsx">XLSX</option>
          <option value="csv">CSV</option>
        </select>
      </div>
    </div>
    <div class="col-md-12">
      <div class="w-100 text-center mt-2">
        <!-- <button
          type="button" class="btn btn-default btn-sm btn-right"
          (click)="cancelDownloadReport()">
          {{ 'Cancel' | translate }}
        </button> -->
        <button type="submit" class="btn btn-light btn primary-btn">
          {{ 'Save' | translate }}
        </button>
      </div>
    </div>
  </form>
</p-dialog>




<!-- QA Dialog -->
<p-dialog
  [(visible)]="showDialogQA" [responsive]="true"
  [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true" [positionTop]="100">
  <ng-template pTemplate="header">
    
    {{ 'Cabin Survey' | translate }}
  
  </ng-template>
  
<div *ngIf="temp_assistance_case">
  <span *ngIf="ambulance_id.indexOf(temp_assistance_case.services[0].id) == -1 && information_id.indexOf(temp_assistance_case.services[0].id) == -1">
    <span class="btn btn-light btn primary-btn"
  (click)="showsubSurvey(
      groupClass.ASSISTANCE_CASE_CABIN_SURVEY
    )">
    {{ 'Cabin Process' | translate }}
  </span>
</span>

<span *ngIf="ambulance_id.indexOf(temp_assistance_case.services[0].id) == -1 && information_id.indexOf(temp_assistance_case.services[0].id) == -1">
<span class="btn btn-light btn primary-btn"
(click)="showsubSurvey(
    groupClass.ASSISTANCE_CASE_DISPATCH_SURVEY
  )">
  {{ 'Dispatch Process' | translate }}
</span>
</span>

<span *ngIf="ambulance_id.indexOf(temp_assistance_case.services[0].id) == -1 && information_id.indexOf(temp_assistance_case.services[0].id) == -1">
  <span class="btn btn-light btn primary-btn"
    (click)="showsubSurvey(
      groupClass.ASSISTANCE_CASE_COMPLETE_SURVEY
  )">
  {{ 'Complete Process (Cabin + Dispatch)' | translate }}
</span>
</span>


<span
>
<span class="btn btn-light btn primary-btn" *ngIf="information_id.indexOf(temp_assistance_case.services[0].id) >= 0 "
  (click)="showsubSurvey(
      groupClass.ASSISTANCE_CASE_INFORMATION_SURVEY
    )">
    {{ 'Information' | translate }}
  </span>
</span>



<!--(139,140,155,241,475,518,521,522,526,531,532,619,631,637)  [1,2,3,4].indexOf(assistancecase.services[0].id) >= 0   // <tr *ngFor="let service of assistancecase.services">-->
 
  <span *ngIf="ambulance_id.indexOf(temp_assistance_case.services[0].id) >= 0 && information_id.indexOf(temp_assistance_case.services[0].id) == -1">
  <span   class="btn btn-light btn primary-btn"
    (click)="showsubSurvey(
      groupClass.ASSISTANCE_CASE_CABIN_SURVEY_AMBULANCE
    )">
    {{ 'Cabin Process (ambulance)' | translate }}
  </span>
  </span>
  
  <span *ngIf="ambulance_id.indexOf(temp_assistance_case.services[0].id) >= 0 && information_id.indexOf(temp_assistance_case.services[0].id) == -1">
  <span class="btn btn-light btn primary-btn"
    (click)="showsubSurvey(
      groupClass.ASSISTANCE_CASE_DISPATCH_SURVEY_AMBULANCE
    )">
    {{ 'Dispatch Process (ambulance)' | translate }}
  </span>
  </span>
  
  <span *ngIf="ambulance_id.indexOf(temp_assistance_case.services[0].id) >= 0 && information_id.indexOf(temp_assistance_case.services[0].id) == -1">
  <span class="btn btn-light btn primary-btn"
    (click)="showsubSurvey(
      groupClass.ASSISTANCE_CASE_COMPLETE_SURVEY_AMBULANCE
    )">
    {{ 'Complete Process (ambulance)' | translate }}
  </span>
  </span>

</div>

</p-dialog>
<!-- Survey Dialog -->
<p-dialog
  [(visible)]="showSurcveyDialog" [responsive]="true"
  [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true" [positionTop]="100">
  <ng-template pTemplate="header">
    
    {{ 'Survey Answers' | translate }}
  
  </ng-template>
  
  <app-individual-case-survey-form

    [editdata]="editsurvey"
    [isTD]="isTD"
    [type_case]="type_case"
    [survey_type]="survey_type"
    (update)="onUpdateSurvey($event)"
    (cancelEvent)="onCancel()"
    #individualSurvey>
  </app-individual-case-survey-form>
</p-dialog>



<!-- Survey Dialog 2 -->
<p-dialog
  [(visible)]="showDialogQA2" [responsive]="true"
  [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true" [positionTop]="100">
  <ng-template pTemplate="header">
    
    {{ 'Survey Answers' | translate }}
  
  </ng-template>
  
  <div class="form-group">
    <div class="col-sm-12">
      <label *ngIf="questions_officer" class="control-label question">
       {{ 'Channel' | translate}}:  {{channel[questions_officer[0][0].answered_from]}} 
      </label>
    </div>
  </div> 
  <br>
  <div class="form-group">
    <div class="col-sm-12">
      <label *ngIf="questions_officer" class="control-label question">
       {{ 'Comment' | translate}}: {{questions_officer[0][0].approved_comment}}
      </label>
    </div>
  </div> 
  <div class="question" *ngFor="let question of questions_officer">
    <div class="form-group">
      <div class="col-sm-12">
        <label class="control-label question">
          {{question[1].question}}
        </label>
      </div>
    </div> 
    <div class="form-group">
      <div class="col-sm-12">
        <select class="form-control">
          <option>
            {{(question[1].id == 180 ) ? question[0].value : answers1[question[0].value]}}
          </option>
          
        </select>
        
      </div>
    </div>
    <br>
  </div>

  <div class="form-group">
    <div class="col-sm-12">
      <label class="control-label question">
        {{'comment client' | translate}}:
      </label>
    </div>
  </div> 
  <div class="col-sm-12">
    <textarea
      class="form-control" [(ngModel)]="comment_user"
      name="Comment2" readonly>
    </textarea>
  </div>

  <div  *ngIf="iAm(['risk_officer'])">
    <table aria-label="apply2table" class="col-sm-12">
      <th scope="col"></th>
      <tr>
        <td class="control-label col-sm-3">
          <label>{{ 'Apply2' | translate }}:</label>
        </td>
        <td class="col-sm-1" style="text-align: right; padding-right: 0px;">
          <input
            type="radio" [ngModel]="fit_criteria" name="criteria"
            (click)="aplica(1)" [value]=1>
        </td>
        <td
          class="col-sm-2" style="text-align: left; cursor:pointer"
          (click)="aplica(1)">
          {{ 'Yes' | translate }}
        </td>
        <td
          class="col-sm-1" style="text-align: right; padding-right: 0px;">
          <input
            type="radio" [ngModel]="fit_criteria" name="criteria"
            (click)="aplica(0)" [value]=0>
        </td>
        <td
          class="col-sm-3" style="text-align: left; cursor:pointer"
          (click)="aplica(0)">
          {{ 'No' | translate }}
        </td>
        <td class="col-sm-2"></td>
      </tr>
    </table>

    <div class="form-group">
      <label class="control-label col-sm-3">
        {{ 'Comment' | translate }}:
      </label>
      <div class="col-sm-9">
        <textarea
          class="form-control" [(ngModel)]="approved_comment"
          name="Comment">
        </textarea>
      </div>
    </div>
  </div>
  <br>
  <br>
  <button
    *ngIf="iAm(['risk_officer'])"
    class="btn btn-success btn-sm btn-right" (click)="aplica2()">
    {{ 'Save' | translate }}
  </button>
</p-dialog>

<!-- Re assign users Dialog -->
<p-dialog
  [(visible)]="showDialogReasignUsers"
  [modal]="true" [draggable]="false" [style]="{width: '65vw'}"
  [class.ui-dialog-titlebar]="true" [blockScroll]="true" >
  <ng-template pTemplate="header">
    {{ 'Manage assessors' | translate }}
  </ng-template>
  
  <form class="filter-dialog-form">

    <div>

      <div class="filter-item" *ngIf="manualReassignment">
        <label class="lbl-top-margin">
          {{ 'Case IDs' | translate }}
        </label>

        <div class="d-flex gap-3 mb-2" role="group">
          <div>
            <label class="radio-inline" for="modeSingle">
              <input type="radio" name="mode" id="modeSingle" [(ngModel)]="inputMode" value="single">  Individual / Comas
            </label>
          </div>
          <div>
            <label class="radio-inline" for="modeBulk">
              <input type="radio" name="mode" id="modeBulk" [(ngModel)]="inputMode" value="bulk"> Carga Masiva
            </label>
          </div>
        </div>

        <div *ngIf="inputMode === 'bulk'">
          <small class="text-muted d-block mb-1">Asignar estos casos como:</small>
          <div class="d-flex gap-3">
            <div>
              <label class="radio-inline" for="roleOp">
                <input type="radio" name="assignRole" id="roleOp" [(ngModel)]="assignRole" value="operator">  {{ 'Operator' | translate }}
              </label>
            </div>
            <div>
              <label class="radio-inline" for="roleDes">
                <input type="radio" name="assignRole" id="roleDes" [(ngModel)]="assignRole" value="dispatcher"> {{ 'Dispatcher' | translate }}
              </label>
            </div>
          </div>
        </div>

        <div [ngSwitch]="inputMode">
          <input *ngSwitchCase="'single'"
                name="cases_ids" 
                class="form-control" 
                placeholder="Ej: 441812, 441805" 
                [(ngModel)]="assistance_cases_ids">

          <div *ngSwitchCase="'bulk'">
            <textarea name="cases_ids_bulk" 
                      class="form-control" 
                      rows="5"
                      [placeholder]="'Pegue aquí: No. Caso  Email'" 
                      [(ngModel)]="assistance_cases_ids"
                      (blur)="formatCaseData()">
            </textarea>
            <div class="d-flex justify-content-between mt-1">
              <small class="text-muted italic">* Formato: ID [Tab] Email</small>
              <span class="badge bg-info" *ngIf="processedCases.length > 0">
                {{ processedCases.length }} registros detectados
              </span>
            </div>
          </div>
        </div>
      </div>
      <br *ngIf="manualReassignment">
      <br *ngIf="manualReassignment">

      <!-- Operator -->
      <div class="filter-item" *ngIf="inputMode === 'single'">
        <label class="lbl-top-margin">
          {{ 'Operator' | translate }}
        </label>

        <form style="padding: 0px 10px 10px 10px;">
          <label class="radio-inline">
            <input type="radio" name="valueAssignOperator" [(ngModel)]="valueAssignOperator" [value]="0">{{ 'None' | translate }}
          </label>
          <label class="radio-inline">
            <input type="radio" name="valueAssignOperator" [(ngModel)]="valueAssignOperator" [value]="1">{{ 'Unassign' | translate }} {{ 'Operator' | translate }}
          </label>
          <label class="radio-inline">
            <input type="radio" name="valueAssignOperator" [(ngModel)]="valueAssignOperator" [value]="2">{{ 'Re assign' | translate }} {{ 'Operator' | translate }}
          </label>
        </form>

        <app-user-select [disabled]="valueAssignOperator != 2" #selectOperator [roles]="['assistance_admin', 'supervisor', 'operator', 'assistance_dispatcher', 'assistance_dispatcher_medical', 'assistance_dispatcher_vial', 'assistance_dispatcher_vip', 'assistance_operator_vip']"
          (onSelect)="onSelectOperator($event)" (onClear)="onClearSelectOperator()"
          (onQuery)="onQueryOperator($event)">
        </app-user-select>
      </div>
      <br>
      <br>

      <!-- Dispatcher -->
      <div class="filter-item" *ngIf="inputMode === 'single'">
        <label class="lbl-top-margin">
          {{ 'Dispatcher' | translate }}
        </label>

        <form style="padding: 0px 10px 10px 10px;">
          <label class="radio-inline">
            <input type="radio" name="valueAssignDispatcher" [(ngModel)]="valueAssignDispatcher" [value]="0">{{ 'None' | translate }}
          </label>
          <label class="radio-inline">
            <input type="radio" name="valueAssignDispatcher" [(ngModel)]="valueAssignDispatcher" [value]="1">{{ 'Unassign' | translate }} {{ 'Dispatcher' | translate }}
          </label>
          <label class="radio-inline">
            <input type="radio" name="valueAssignDispatcher" [(ngModel)]="valueAssignDispatcher" [value]="2">{{ 'Re assign' | translate }} {{ 'Dispatcher' | translate }}
          </label>
        </form>

        <app-user-select [disabled]="valueAssignDispatcher != 2" #selectDispatcher [roles]="['assistance_admin', 'supervisor', 'operator', 'assistance_dispatcher', 'assistance_dispatcher_medical', 'assistance_dispatcher_vial', 'assistance_dispatcher_vip', 'assistance_operator_vip']"
          (onSelect)="onSelectDispatcher($event)" (onClear)="onClearSelectDispatcher()"
          (onQuery)="onQueryDispatcher($event)">
        </app-user-select>
      </div>
      <br>
      <br>
    </div>


    <div class="text-center" style="margin: 10px 0;">
      <button
        class="btn btn-light btn primary-btn" (click)="reasignUsers()">
        <i class="fa fa-users" aria-hidden="true"></i>
        {{ 'Re assign users' | translate }}
      </button>
    </div>
  </form>
</p-dialog>
